class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));

    this.mainDetailsToggle.addEventListener('mouseenter', this.open.bind(this))
    this.mainDetailsToggle.addEventListener('mouseleave', () => this.close(false))
  }

  onFocusOut() {
    
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '')
  }

  close(force = true) {
    this.mainDetailsToggle.removeAttribute('open');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
